import { StyledFlex, TextView } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { AdjustmentDataText } from '../../adjustment/AdjustmentDataText';

import { PreviousAdjustmentFormBean } from './adjustment.types';

const t = visitSettlementTranslationKeys.shared.form.adjustment.previousNote;

type PreviousAdjustmentNoteTextViewProps = {
   readonly previousAdjustment: PreviousAdjustmentFormBean;
};

export const PreviousAdjustmentNote = (props: PreviousAdjustmentNoteTextViewProps): JSX.Element => {
   return (
      <TextView label={t.label} testId={'previousAdjustmentNote'}>
         <StyledFlex direction={'column'} gap={'4px'}>
            {props.previousAdjustment.note}
            {props.previousAdjustment.by ? (
               <AdjustmentDataText
                  author={props.previousAdjustment.by.author}
                  date={props.previousAdjustment.by.date}
               />
            ) : null}
         </StyledFlex>
      </TextView>
   );
};
